import { useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Signin from "./Pages/Signin";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Merchantsign from "./Pages/Merchantsign";
import Usersign from "./Pages/Usersign";
import Vendorhomepage from "./Pages/Vendorhomepage";
import Changepass from "./Components/Changepass";
import Changephone from "./Components/Changephone";
import axios from "axios";
import Userhomepage from "./Pages/Userhomepage";


function App() {
  const [otp, setOtp] = useState([]);

  const sendotp = async (type, input) => {
    const formData = new FormData();
    formData.append("format", type);
    formData.append("user_input", input);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/login_forgotpass.php`,
        formData
      );
      const data = res.data?.data || res.data;
      if (data) {
        setOtp(data);
      }
    } catch (err) {
      console.error("Error fetching orders", err);
    }
  };

  const verifyotp = async (type, input) => {
    const formData = new FormData();
    formData.append("type", type);
    formData.append("vendor_id", "1");
    formData.append("enterotp", input);
    // formData.append("sendotp", otp?.otp);
    // formData.append("iv", otp?.iv);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/verifyotp.php`,
        formData
      );
      const data = res.data?.data || res.data;

      // ✅ Check success using message
      if (data.message?.toLowerCase().includes("otp verified")) {
        return true;
      }

      return false;
    } catch (err) {
      console.error("Error verifying OTP", err);
      return false;
    }
  };

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/signin" element={<Signin />} />
          <Route path="/AmbrosysSign" element={<Merchantsign />} />
          <Route path="/Usersign" element={<Usersign />} />
          <Route path="/changepassword" element={<Changepass />} />
          <Route path="/changephoneno" element={<Changephone />} />
          <Route path="/*" element={<Userhomepage />} />
          <Route
            path="/vendor/*"
            element={<Vendorhomepage sendotp={sendotp} verifyotp={verifyotp} />}
          />
        </Routes>
      </Router>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
      />          
    </div>
  );
}

export default App;   